import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CountryCode, getCountryCallingCode } from 'libphonenumber-js';
import { motion } from 'motion/react';
import { useState } from 'react';

import { palettenext } from '../../../../color/palette-next';
import { Box } from '../../../Box/Box';
import { Inline } from '../../../Inline/Inline';
import { Text } from '../../../Text/Text';
import { Flag } from '../../components/Flag';
import { FlagMenu } from '../FlagMenu';
import { phoneFieldFlagSelectorButtonStyle } from './styles.css';

export function FlagSelector(props: {
  id?: string;
  disabled?: boolean;
  countryCode: CountryCode;
  onChange: (countryCode: CountryCode) => void;
}) {
  const [showFlagMenu, setShowFlagMenu] = useState(false);

  const toggleMenu = () => {
    setShowFlagMenu((state) => !state);
  };

  const handleSelect = (countryCode: CountryCode) => {
    setShowFlagMenu(false);
    props.onChange(countryCode);
  };

  return (
    <>
      <Box
        id={props.id}
        display="flex"
        justifyContent="center"
        alignItems="center"
        component="button"
        type="button"
        tabIndex={0}
        aria-haspopup="true"
        aria-expanded={showFlagMenu}
        disabled={props.disabled}
        className={phoneFieldFlagSelectorButtonStyle}
        onClick={toggleMenu}
      >
        <Box marginY="small">
          <Inline alignY="center" gap="xsmall">
            <Flag countryCode={props.countryCode} />
            <Text>+{getCountryCallingCode(props.countryCode)}</Text>
            <FontAwesomeIcon
              size="sm"
              color={palettenext.neutral[400]}
              icon={showFlagMenu ? faAngleUp : faAngleDown}
            />
          </Inline>
        </Box>
      </Box>
      {showFlagMenu && (
        <motion.div
          initial={{ opacity: 0, transform: 'scale(0.95, 0.95)' }}
          animate={{ opacity: 1, transform: 'scale(1)' }}
          transition={{ duration: 0.2 }}
          exit={{ opacity: 0, transform: 'scale(0.95, 0.95)' }}
          // @ts-expect-error - permissible
          style={{ zIndex: 10 }}
        >
          <FlagMenu
            onSelect={handleSelect}
            onClose={() => {
              setShowFlagMenu(false);
            }}
          />
        </motion.div>
      )}
    </>
  );
}
